import { render, staticRenderFns } from "./EmailNav.vue?vue&type=template&id=a633bf4c&"
import script from "./EmailNav.vue?vue&type=script&lang=js&"
export * from "./EmailNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports